/*
 * hero-video.js
 *
 * Laduje TYLKO ten film hero, ktory jest faktycznie widoczny.
 *
 * Sekcja renderuje dwa <video> — poziomy na desktop i pionowy na telefon —
 * a CSS ukrywa niepasujacy. Gdyby oba mialy `src` od razu, przegladarka
 * pobralaby oba pliki (2,5 MB + 1 MB) i polowa transferu bylaby zmarnowana.
 *
 * Dlatego zrodlo siedzi w data-hero-src, a `src` dostaje wylacznie element
 * z niezerowym pudelkiem. Plakat (poster) jest widoczny od razu, wiec
 * uzytkownik nie oglada dziury podczas ladowania.
 */
(function () {
  'use strict';

  function isVisible(el) {
    if (el.offsetParent !== null) return true;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function activate(video) {
    if (video.dataset.heroLoaded === '1') return;

    var src = video.getAttribute('data-hero-src');
    if (!src) return;

    video.dataset.heroLoaded = '1';
    video.src = src;
    video.preload = 'auto';
    video.load();

    // autoplay+muted zwykle wystarcza, ale po recznym load() Safari
    // potrafi nie wystartowac. Odmowe ignorujemy — plakat zostaje.
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function scan() {
    var vids = document.querySelectorAll('video[data-hero-src]');
    for (var i = 0; i < vids.length; i++) {
      if (isVisible(vids[i])) activate(vids[i]);
    }
  }

  scan();

  // Obrot tabletu albo przejscie przez breakpoint moze odslonic drugi wariant
  var t = null;
  window.addEventListener(
    'resize',
    function () {
      if (t) clearTimeout(t);
      t = setTimeout(scan, 250);
    },
    { passive: true }
  );

  // Edytor motywu przeladowuje sekcje bez odswiezania strony
  document.addEventListener('shopify:section:load', scan);
})();
